// extracted by mini-css-extract-plugin
export default {"container":"bGgjMrjvIp4qJ8bj0nI9QA==","list":"_43VLACv6ySMCRhboqW2iIQ==","listItem":"ZWsB4l-cATCk8ns0DDVMHg==","wholeWidth":"GuoW-GH6xTjpJZfctLuOJA=="};